import React, { useEffect, useRef } from 'react';
import { defaultLayoutIcons, DefaultVideoLayout } from '@vidstack/react/player/layouts/default';
import { MediaPlayer, MediaProvider, Poster, useMediaState } from '@vidstack/react';

import {SimpleImage} from './image-simple.jsx';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/media.d.ts').Video}
 */
const Video = ({
    height,
    onFullscreenChange,
    onPlayingStateChange,
    playButtonPosition = 'bottom-left',
    poster,
    src,
    title = '',
    width,
}) => {
    const playerRef = useRef(null);

    const startPlay = () => {
        playerRef.current.play?.();
    };
    const isStarted = useMediaState('started', playerRef);
    const isPlaying = useMediaState('playing', playerRef);

    useEffect(() => {
        if (onPlayingStateChange) {
            onPlayingStateChange(!isPlaying);
        }
    }, [isPlaying, onPlayingStateChange]);

    return (
        <MediaPlayer
            crossOrigin
            playsInline
            aspectRatio={width && height ? `${width}/${height}` : '16/9'}
            load='play'
            onFocus={() => {
                playerRef.current.controls?.show?.();
            }}
            onFullscreenChange={onFullscreenChange}
            posterLoad='eager'
            ref={playerRef}
            src={src}
            title={title}>
            <MediaProvider>
                {poster && (
                    <Poster
                        asChild
                        alt='Video placeholder image'
                        className={`vds-poster ${isStarted ? 'hidden' : ''}`}>
                        <SimpleImage src={poster} />
                    </Poster>
                )}
                {!isStarted && (
                    <div className={`absolute z-50
                        ${playButtonPosition === 'bottom-left' ? 'left-5 bottom-5' : ''}
                        ${playButtonPosition === 'center' ? 'left-0 right-0 text-center' : ''}
                    `}>
                        <button
                            className='px-10 py-5 inline-flex items-center type-style-7 bg-white rounded'
                            onClick={startPlay.bind(null)}
                            type='button'>
                            {'Play'}
                        </button>
                    </div>
                )}
            </MediaProvider>
            {isStarted && (
                <DefaultVideoLayout
                    icons={defaultLayoutIcons}
                    slots={{
                        title: null,
                        chapterTitle: null,
                        airPlayButton: null,
                        googleCastButton: null
                    }} />
            )}
        </MediaPlayer>
    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

export default Video;
